// Import-free: col-defs read these values mid-evaluation, and an imported home leaves the enum undefined right then.

// Values are the literals the API's TagRelation entity_type enum accepts verbatim.
export enum SupportedTagEntityTypes {
  PROJECT = 'Project',
  ASSET = 'Asset',
  OPPORTUNITY = 'Opportunity',
  CASE = 'Case',
  QUOTE = 'Quote',
  QUOTE_LINE_ITEM = 'QuoteLineItem',
  OUTSIDE_INVENTORY = 'OutsideInventory'
}
